/**
 * Statuswerte auf Deutsch - an einer Stelle.
 *
 * In der Datenbank stehen die Aufgaben-Status seit jeher englisch ("Open",
 * "In Progress", "Done", "Dismissed"). Das ist der gespeicherte Wert und
 * bleibt es auch: Er steckt in Abfragen, Berichten, Auswertungen und in
 * jedem vorhandenen Datensatz - ihn umzuschreiben waere eine Wanderung
 * durch den gesamten Bestand, ohne dass irgendwer davon etwas hat.
 *
 * Gezeigt wird dem Team aber Deutsch. Diese Datei ist die einzige Stelle,
 * an der beides zusammenkommt - wer eine Anzeige baut, nimmt das Label und
 * schickt weiterhin den Wert ans Backend.
 */

/** Aufgaben / Follow-ups: gespeicherter Wert -> Anzeige. */
export const AUFGABEN_STATUS = [
  { wert: "Open", label: "Offen" },
  { wert: "In Progress", label: "In Arbeit" },
  { wert: "Done", label: "Erledigt" },
  { wert: "Dismissed", label: "Verworfen" },
];

const AUFGABEN_LABEL = Object.fromEntries(
  AUFGABEN_STATUS.map((s) => [s.wert, s.label]));

/**
 * Anruf-Bearbeitung: hier stehen deutsche Werte in der Datenbank, aber
 * nicht alle sind vorzeigbar - "rueckruf_offen" ist ein Schluessel, kein
 * Satz. Was schon lesbar ist, bleibt wie es ist.
 */
const GESPRAECH_LABEL = {
  neu: "Neu",
  offen: "Offen",
  wartet: "Wartet",
  erledigt: "Erledigt",
  rueckruf_offen: "Rückruf offen",
  "in Bearbeitung": "In Bearbeitung",
};

/** Status einer Aufgabe auf Deutsch. Unbekanntes bleibt, wie es kam -
 *  ein leeres Feld waere schlimmer als ein ungewohntes Wort. */
export function aufgabenStatus(wert) {
  if (!wert) return "";
  return AUFGABEN_LABEL[wert] || wert;
}

/** Bearbeitungsstand eines Gesprächs auf Deutsch. */
export function gespraechStatus(wert) {
  if (!wert) return "";
  return GESPRAECH_LABEL[wert] || wert;
}
